module.exports = __webpack_public_path__ + "media/images/homes/ImportyourcustomerlistintoBOLDPOS-e45e05835ed9d2c863b141cc079f96c1.png";